<template>
  <footer class="white bg-white position-relative mt-xl-0">
    <div class="footer-bg" data-src="/chrs-resources/images/wsl-silhouette.png" lazy="loaded" style="background-image: url('/chrs-resources/images/wsl-silhouette.png')">
      <div class="container-fluid pt-md-4" style="max-width: 1600px">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="row justify-content-md-center">
              <div class="col-12 col-md-6 col-lg-6 text-center text-md-start me-sm-4 me-md-0 mb-sm-4 mb-md-0 pb-5 pb-md-3 black">
                <span class="csub-slogan">`Runners on <br class="d-none d-md-block d-lg-none" />the Rise! <br class="d-none d-md-block d-lg-none" /></span>
              </div>
              <!--SOCIAL MEDIA ICONS-->
              <div class="col-12 col-md-5 col-lg-4 col-xl-3 align-self-end text-center text-md-start pt-5">
                <div class="social-media-icons pt-sm-1 pt-md-2">
                  <a href="https://www.facebook.com/csubakersfield" title="CSU Bakersfield Facebook" target="_blank"><i class="fab fa-facebook-f d-inline-block me-4"></i><span class="d-none">CSU Bakersfield Facebook</span></a><a href="https://twitter.com/csubakersfield" title="CSU Bakersfield Twitter" target="_blank"><i class="fab fa-twitter d-inline-block me-4"></i><span class="d-none">CSU Bakersfield Twitter</span></a><a href="https://www.instagram.com/csubakersfield/" title="CSU Bakersfield Instagram" target="_blank"><i class="fab fa-instagram d-inline-block me-4"></i><span class="d-none">CSU Bakersfield Instagram</span></a><a href="https://www.youtube.com/user/CSUBakersfield" title="CSU Bakersfield YouTube" target="_blank"><i class="fab fa-youtube d-inline-block me-4"></i><span class="d-none">CSU Bakersfield YouTube</span></a><a href="https://www.flickr.com/photos/csubedu/albums/with/72157714211686978" title="CSU Bakersfield Flickr" target="_blank"><i class="fab fa-flickr d-inline-block"></i><span class="d-none">CSU Bakersfield Flickr</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-color-1">
      <div class="container-fluid pt-3 pb-5" style="max-width: 1600px">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-9 col-md-6 col-lg-6">
            <div class="row justify-content-center justify-content-lg-start">
              <div class="col-12 col-md-12 col-lg-auto mb-3 text-center text-md-start">
                <a href="/" class="router-link-active"><img src="@/assets/images/csub-logo-footer.svg" alt="CSU Bakersfield" /></a>
              </div>
              <div class="col-12 col-md-12 col-lg-auto ps-sm-2 ps-md-3 mb-4 fw-bold text-center text-md-start">
                California State University, Bakersfield<br />
                9001 Stockdale Highway<br />
                Bakersfield, CA 93311<br />
                (661) 654-CSUB
              </div>

              <!--GOLD FOOTER BUTTONS-->
              <div class="col-12">
                <ul class="list-inline text-center text-md-start mb-2 mb-md-0">
                  <li class="list-inline-item me-2 mb-2">
                    <a href="/apply" class="btn btn-csub-gold fw-bold" aria-current="page"><i class="fas fa-edit d-inline-block me-1"></i>
                      Apply
                    </a>
                  </li>
                  <li class="list-inline-item me-2 mb-2">
                    <a href="/visit" class="btn btn-csub-gold fw-bold"><i class="fas fa-map-marker-alt d-inline-block me-1"></i>
                      Visit
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a href="/contact" class="btn btn-csub-gold fw-bold"><i class="fas fa-envelope d-inline-block me-1"></i>
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <hr class="d-block d-md-none bg-white" />
          </div>

          <!--FOOTER TEXT LINKS-->
          <div class="col-12 col-sm-9 col-md-5 col-lg-4 col-xl-3 text-center text-md-start">
            <ul class="list-unstyled footer-static-links mb-sm-4 mb-md-0">
              <li><a href="/equity-inclusion-compliance/ada" class="text-decoration-none">Accessibility</a></li>
              <li><a href="/equity-inclusion-compliance/clery" class="text-decoration-none">Annual Security Report</a></li>
              <li><a href="/budget/budgetCentral/index.html" target="_blank" rel="noopener" class="text-decoration-none">Budget Central</a></li>
              <li><a href="https://directory.csub.edu/" target="_blank" rel="noopener" class="text-decoration-none">Campus Directory</a></li>
              <li><a href="/forms/index.html" target="_blank" rel="noopener" class="text-decoration-none">Campus Forms</a></li>
              <li><a href="/hr/careers" class="text-decoration-none">Careers</a></li>
              <li><a href="/dmca" class="text-decoration-none">DMCA/Copyright</a></li>
              <li><a href="/bas/police/emergency/index.html" target="_blank" rel="noopener" class="text-decoration-none">Emergency Info</a></li>
              <li><a href="https://library.csub.edu/" target="_blank" rel="noopener" class="text-decoration-none">Library</a></li>
              <li><a href="https://maps.csub.edu/" target="_blank" rel="noopener" class="text-decoration-none">Maps</a></li>
              <li><a href="https://www.calstate.edu/csu-system/doing-business-with-the-csu/capital-planning-design-construction/Documents/BK%20map.pdf" target="_blank" rel="noopener" class="text-decoration-none">Master Plan</a></li>
              <li><a href="/events" class="text-decoration-none">Plan an Event</a></li>
              <li><a href="/policies" class="text-decoration-none">Policies</a></li>
              <li><a href="/privacy" class="text-decoration-none">Privacy</a></li>
              <li><a href="/report-website-issue" class="text-decoration-none">Report a Website Issue</a></li>
              <li><a href="/returntocampus" class="text-decoration-none">Return to Campus</a></li>
              <li><a href="/bas/police/_files/CampusSafetyPlan.pdf" target="_blank" rel="noopener" class="text-decoration-none">Safety Plan</a></li>
              <li><a href="/sitemap" class="text-decoration-none">Sitemap</a></li>
              <li><a href="/strategicplan" class="text-decoration-none">Strategic Plan</a></li>
              <li><a href="/sustainability" class="text-decoration-none">Sustainability</a></li>
              <li><a href="/equity-inclusion-compliance/title-ix" class="text-decoration-none">Title IX</a></li>
              <li><a href="/bas/police/index.html" target="_blank" rel="noopener" class="text-decoration-none">University Police</a></li>
            </ul>
            <hr class="d-block d-md-none bg-white" />
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-12 col-sm-9 col-md-11 col-lg-10 col-xl-9 text-center text-md-start mt-md-3">
            © California State University, Bakersfield
            <div class="small">
              <span><a href="http://get.adobe.com/reader/" target="_blank" class="text-decoration-none">Adobe Reader</a> <span>| </span></span>
              <span><a href="https://www.microsoft.com/en-us/download" target="_blank" class="text-decoration-none">Microsoft Viewers</a></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Page-Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
